import React from 'react';
import '../../styles/CaseStudyThree/CaseStudiesBeginning3.css';
import productIcon1 from '../../assets/three-people-bullseye.png';
import productIcon2 from '../../assets/pink-bullseye.png';
import productIcon3 from '../../assets/glass-and-cog.png';

const SectionBeginning3 = () => {
  return (
    <section className="beginning-section3">
      <div className="beginning-container3">
        {/* Title */}
        <h2 className="beginning-title3">The Beginning</h2>

        {/* Product/Service Boxes */}
        <div className="product-service-container3">
          <div className="product-service-box3">
            <img src={productIcon1} alt="Product 1" className="beginning-product-icon3" />
            <p>Audience segmentation and analysis</p>
          </div>
          <div className="product-service-box">
            <img src={productIcon2} alt="Product 2" className="beginning-product-icon3" />
            <p>Targeted ad placement</p>
          </div>
          <div className="product-service-box">
            <img src={productIcon3} alt="Product 3" className="beginning-product-icon3" />
            <p>Campaign optimization</p>
          </div>
        </div>

        {/* Description Text */}
        <p className="beginning-description3">
        Hawx Pest Control offers reliable pest control solutions, but they faced challenges in reaching the right audience with their advertising campaigns. 
        Their original targeting strategy included lower-income households and younger individuals, many of whom were unlikely to convert. 
        We identified key opportunities to improve their advertising by narrowing the target audience to those most likely to benefit from their services.
        </p>

      </div>
    </section>
  );
};

export default SectionBeginning3;

